import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (email, password, name) => {
    const { data } = await http.post("/auth/register", { email, password, name });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await http.post("/auth/logout"); } catch (err) { console.error("logout endpoint failed", err); }
    setUser(false);
  };
  const setUserData = (u) => setUser(u);

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, checkAuth, setUserData, formatApiError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
